import WidgetCard from "@/components/cards/widget-card";
import Table from "@/components/table";
import { useTanStackTable } from "@/components/table/custom/use-TanStack-Table";
import { defaultData } from "@/data/tan-table-data";
import { useDirection } from "@/hooks/use-direction";
import { defaultColumns } from "./column";

export type PersonType = (typeof defaultData)[number];

export default function TableResizable() {
    const { direction } = useDirection();
    const { table, setData } = useTanStackTable<PersonType>({
        tableData: defaultData,
        columnConfig: defaultColumns,
        options: {
            initialState: {
                pagination: {
                    pageIndex: 0,
                    pageSize: 7,
                },
            },
            meta: {
                handleDeleteRow: (row) => {
                    setData((prev) => prev.filter((r) => r.id !== row.id));
                },
            },
            columnResizeDirection: direction as any,
            columnResizeMode: "onChange",
        },
    });

    return (
        <WidgetCard title="Resizable Table" className="space-y-4">
            <Table
                table={table}
                variant="modern"
                classNames={{
                    rowClassName: "last:border-0",
                }}
            />
        </WidgetCard>
    );
}
